export default {
    namespaced: true,
    pbx_master_account: {
      title: "Master Account | Master Accounts",
      name: "name",
      domain: "domain",
      sip_port: "SIP port",
      tls_sip_port: "TLS SIP port",
      ws_url: "WS URL",
      ws_binding_port: "WS port",
      wss_binding_port: "WSS port",
      external_sip_ip: "External SIP IP",
      external_rtp_ip: "External RTP IP",
      call_recording: "Call recording enabled",
      queue_timeout: "Queue timeout",
      seconds: "seconds",
      api_url: "API URL",
    },
  };
